// @flow
import React, { useState, useMemo, useEffect } from "react";
import { Button, styled } from "@material-ui/core";
import InputField from "../../../../components/ui/inputField";
import NumberFormat from "react-number-format";
import ValidatedDatePicker from "../../../../components/ui/DatePicker";
import Modal from "react-bootstrap/Modal";
import axios from "../../../../axios-order";
import classes from "./tdsPayables.module.css";
// import classes from "./tdsPaybles.module.css";
import { ValidatorForm } from "react-material-ui-form-validator";
import { toast } from "react-toastify";

import SelectField from "../../../../components/ui/select";
import TextField from "@mui/material/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

const StyledAutoComplete = styled(Autocomplete)(() => ({
  "& legend": {
    display: "none",
  },

  "& input": {
    height: 0,
  },
}));

export default function Add(props) {
  const {
    cancelAddForm,
    updateTable,
    updateMasterTable,
    updateReversalOfProvision,
  } = props;

  const [vendorTableData, setVendorTableData] = useState([]);
  const [dataForSearch, setDataForSearch] = useState([]);
  const [addTdsData, setAddTdsData] = useState({});
  const [openVendorModal, setOpenVendorModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState("");

  // --- New Logic State ---
  const [sectionMapping, setSectionMapping] = useState([]); 
  const [sectionDropdownValue, setSectionDropdownValue] = useState([]);
  const [sectionNewDropdownValue, setSectionNewDropdownValue] = useState([]);

  // ✅ CHANGE 1: Added to store full lists for reset
  const [allSectionOptions, setAllSectionOptions] = useState([]);
  const [allSectionNewOptions, setAllSectionNewOptions] = useState([]);

  const getAllVendormasterData = () => {
    setLoading(true);
    axios
      .get(`/get_provison_master/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        setLoading(false);
        setVendorTableData(res.data.record);
        setDataForSearch(res.data.record);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const addInputChangeHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    setAddTdsData({
      ...addTdsData,
      [name]: value,
    });
  };

  useEffect(() => {
    fetchSectionDropdown();
  }, []);

  // ✅ CHANGE 2: fetchSectionDropdown now populates BOTH dropdowns on load with deduplicated values
  const fetchSectionDropdown = () => {
    axios
      .get("/get_tds_section_dropdown")
      .then((res) => {
        const apiData = res.data.record || res.data;

        // Store full mapping for filtering
        setSectionMapping(apiData);

        // Deduplicate Section values (API has duplicate entries like 194A x3, 194B x2 etc.)
        const uniqueSections = [
          ...new Map(apiData.map((item) => [item.section, { section: item.section }])).values(),
        ];
        setSectionDropdownValue(uniqueSections);
        setAllSectionOptions(uniqueSections); // store for reset

        // Extract ALL unique Section New values across entire API data for initial load
        const uniqueSectionNew = [
          ...new Set(apiData.flatMap((item) => item.section_new || [])),
        ].map((s) => ({ section: s }));
        setSectionNewDropdownValue(uniqueSectionNew);
        setAllSectionNewOptions(uniqueSectionNew); // store for reset
      })
      .catch((err) => {
        console.error("Error fetching section dropdown:", err);
        setSectionDropdownValue([]);
        setSectionNewDropdownValue([]);
      });
  };

  // Section → filters Section New
  const handleSectionSelection = (selectedSectionValue) => {
    if (!selectedSectionValue) {
      // Cleared — reset both back to full lists
      // ✅ CHANGE 3: use allSectionOptions / allSectionNewOptions instead of recomputing
      setSectionDropdownValue(allSectionOptions);
      setSectionNewDropdownValue(allSectionNewOptions);
      setAddTdsData({ ...addTdsData, tds_section: "", section_new: "" });
      return;
    }

    const matched = sectionMapping.find(
      (item) => item.section.toUpperCase() === selectedSectionValue.toUpperCase()
    );

    let newOptions = [];
    let autoSectionNew = "";

    if (matched && matched.section_new) {
      newOptions = matched.section_new.map((s) => ({ section: s }));
      // Auto-select if only one option exists
      if (newOptions.length === 1) {
        autoSectionNew = newOptions[0].section;
      }
    }

    setSectionNewDropdownValue(newOptions);
    setAddTdsData({
      ...addTdsData,
      tds_section: selectedSectionValue,
      section_new: autoSectionNew,
    });
  };

  // Section New → filters Section (bidirectional)
  const handleSectionNewSelection = (e) => {
    const selectedSectionNew = e.target.value;

    if (!selectedSectionNew) {
      // Cleared — restore full Section dropdown
      // ✅ CHANGE 3: use allSectionOptions / allSectionNewOptions instead of recomputing
      setSectionDropdownValue(allSectionOptions);
      setSectionNewDropdownValue(allSectionNewOptions);
      setAddTdsData({ ...addTdsData, section_new: "" });
      return;
    }

    const matchedSections = sectionMapping.filter(
      (item) => item.section_new && item.section_new.includes(selectedSectionNew)
    );

    if (matchedSections.length > 0) {
      setSectionDropdownValue(matchedSections.map((item) => ({ section: item.section })));
    }

    // Auto-select Section if only one match
    if (matchedSections.length === 1) {
      setInputValue(matchedSections[0].section);
      setAddTdsData({
        ...addTdsData,
        section_new: selectedSectionNew,
        tds_section: matchedSections[0].section,
      });
    } else {
      setAddTdsData({ ...addTdsData, section_new: selectedSectionNew });
    }
  };

  useMemo(() => {
    let tdsPayable = (addTdsData.amount * addTdsData.tds_percentage) / 100;
    setAddTdsData({
      ...addTdsData,
      tds_payable: tdsPayable,
    });
  }, [addTdsData.amount, addTdsData.tds_percentage]);

  const handleProvisionCreatedDateChange = (v) => {
    if (v != "Invalid Date" && v != null) {
      const pad = "00";
      const yy = v.getFullYear().toString();
      const mm = (v.getMonth() + 1).toString();
      const dd = v.getDate().toString();
      setAddTdsData({
        ...addTdsData,
        provision_create_date: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
      });
    }
  };

  const finalAddData = {
    org_code: localStorage.getItem("business_entity_id"),
    records: [addTdsData],
  };

  const addFormsubmitHandler = (e) => {
    axios
      .post("/tds/provision_vendor", finalAddData)
      .then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message, { autoClose: 2000 });
          updateMasterTable();
          setAddTdsData({});
          updateTable();
          updateReversalOfProvision();
          setInputValue("");
          // ✅ CHANGE 3: reset both dropdowns to full initial lists
          setSectionDropdownValue(allSectionOptions);
          setSectionNewDropdownValue(allSectionNewOptions);
          cancelAddForm();
        } else {
          toast.error(res.data.message, { autoClose: 2000 });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const cancelAddFormHandler = () => {
    cancelAddForm();
    setAddTdsData({});
    setInputValue("");
    // ✅ CHANGE 3: reset both dropdowns to full initial lists
    setSectionDropdownValue(allSectionOptions);
    setSectionNewDropdownValue(allSectionNewOptions);
  };

  const selectVendorModalOpen = () => {
    getAllVendormasterData();
    setOpenVendorModal(true);
  };

  const setVendorDetails = (value) => {
    setAddTdsData({
      ...addTdsData,
      vendor_legal_name: value.vendor_legal_name,
      pan: value.vendor_pan,
      vendor_gstin: value.vendor_gstin,
      vendor_id: value.vendor_id,
    });
    setOpenVendorModal(false);
  };

  const selectVendorModalSearch = (e) => {
    let value = e.target.value;
    const searchresult = dataForSearch.filter((item) => {
      return (
        item.vendor_legal_name.toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
        item.vendor_pan.toLowerCase().indexOf(value.toLowerCase()) >= 0
      );
    });
    setVendorTableData(searchresult);
  };

  const vendorTableBodyData = () => {
    if (vendorTableData && vendorTableData.length > 0) {
      return vendorTableData.map((item, i) => (
        <tr key={i}>
          <td>{item.vendor_legal_name}</td>
          <td>{item.vendor_pan}</td>
          <td>{item.vendor_gstin}</td>
          <td>
            <span style={{ cursor: "pointer" }} onClick={() => setVendorDetails(item)}>
              Select
            </span>
          </td>
        </tr>
      ));
    } else if (loading) {
      return (
        <tr>
          <td style={{ textAlign: "center" }} colSpan={4}>Loading, Please wait...</td>
        </tr>
      );
    } else {
      return (
        <tr>
          <td style={{ textAlign: "center", color: "red" }} colSpan={4}>No Data Found!</td>
        </tr>
      );
    }
  };

  const selectVendorModalClose = () => {
    setOpenVendorModal(false);
  };

  return (
    <>
      <Modal
        size="lg"
        centered
        show={openVendorModal}
        onHide={() => selectVendorModalClose()}
        dialogClassName="modal-50w"
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Any Vendor</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "350px" }}>
          <TextField
            label="Search by legal name and PAN"
            fullWidth
            size="small"
            onChange={selectVendorModalSearch}
          />
          <div className={classes.modalTable}>
            <table className={classes.tablecss}>
              <thead>
                <tr>
                  <th>legal name</th>
                  <th>PAN</th>
                  <th>GSTIN</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>{vendorTableBodyData()}</tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outlined" onClick={selectVendorModalClose}>Cancel</Button>
        </Modal.Footer>
      </Modal>

      <div>
        <button
          style={{ marginTop: "10px", width: "100%" }}
          className="button-outlined-primary"
          onClick={() => selectVendorModalOpen()}
        >
          select Vendor*
        </button>

        <ValidatorForm onSubmit={addFormsubmitHandler}>
          <InputField
            textLabel="Vendor Legal Name"
            name="vendor_legal_name"
            value={addTdsData.vendor_legal_name ?? ""}
            requiredField="*"
            validator={["required"]}
            errorMsg={["This field is required"]}
            textOnchangeFunction={addInputChangeHandler}
            inputProps={{ readOnly: true }}
          />

          <InputField
            textLabel="PAN"
            name="pan"
            value={addTdsData.pan ?? ""}
            requiredField="*"
            validator={["required"]}
            errorMsg={["This field is required"]}
            textOnchangeFunction={addInputChangeHandler}
            inputProps={{ readOnly: true }}
          />

          <div style={{ marginTop: "20px" }}>
            <label>Provision Created Date<span style={{ color: "red" }}>*</span>:</label>
            <ValidatedDatePicker
              name="provision_created_date"
              value={addTdsData.provision_create_date ?? ""}
              onChange={(v) => handleProvisionCreatedDateChange(v)}
              validators={["required"]}
              errorMessages={["This field is required"]}
            />
          </div>

          <div style={{ marginTop: "20px" }}>
            <label>₹ Amount<span style={{ color: "red" }}>*</span>:</label>
            <br />
            <NumberFormat
              className={classes.numberFormate}
              value={addTdsData.amount ?? ""}
              thousandsGroupStyle="lakh"
              prefix="₹"
              decimalSeparator="."
              displayType="number"
              decimalScale={2}
              thousandSeparator={true}
              onValueChange={(values) => {
                setAddTdsData({ ...addTdsData, amount: values.value });
              }}
            />
          </div>

          {/* Added by Vyshnavi */}
          {/* <div style={{ marginTop: "20px" }}>
            <label>
              TDS Section:
            </label>{" "}
            <br />
            <StyledAutoComplete
              id="combo-box-demo"
              style={{ padding: "0!important" }}
              name="tds_section"
              inputValue={inputValue}
              size="small"
              // value={addTdsData.tds_section ?? ""}
              onChange={(e, value) => {
                // if (value === null) {
                //   setAddTdsData({
                //     ...addTdsData,
                //     tds_section: "",
                //   });
                // } else {
                //   setAddTdsData({
                //     ...addTdsData,
                //     tds_section: value.section ?? "",
                //   });
                // }
                setAddTdsData({
                  ...addTdsData,
                  tds_section: value.section.toUpperCase() ?? "",
                });
              }}
              onInputChange={(event, inputValue) => {
                event.preventDefault();
                setInputValue(inputValue);
              }}
              options={sectionDropdownValue}
              getOptionLabel={(option) => option.section}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  name="tds_section"
                />
              )}
            />
          </div> */}
          <div style={{ marginTop: "20px" }}>
            <label>TDS Section<span style={{ color: "red" }}>*</span>:</label>
            <br />
            <StyledAutoComplete
              id="tds-section-autocomplete"
              options={sectionDropdownValue}
              getOptionLabel={(option) => option.section || ""}
              inputValue={inputValue}
              size="small"
              onChange={(e, value) => {
                const selected = value?.section || "";
                handleSectionSelection(selected);
              }}
              onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
              }}
              renderInput={(params) => (
                <TextField {...params} variant="outlined" name="tds_section" required />
              )}
            />
          </div>

          <SelectField
            choice_id="section"
            requiredField="*"
            validator={["required"]}
            errorMsg={["This field is required"]}
            choice_name="section"
            SelectLabel="Section New"
            name="section_new"
            value={addTdsData.section_new ?? ""}
            textOnchangeFunction={handleSectionNewSelection} 
            choices={sectionNewDropdownValue}
          />

          <InputField
            textLabel="TDS %"
            name="tds_percentage"
            value={addTdsData.tds_percentage ?? ""}
            requiredField="*"
            validator={["required"]}
            errorMsg={["This field is required"]}
            textOnchangeFunction={addInputChangeHandler}
          />

          <div style={{ marginTop: "20px" }}>
            <label>₹ TDS Payable<span style={{ color: "red" }}>*</span>:</label>
            <br />
            <NumberFormat
              className={classes.numberFormate}
              value={addTdsData.tds_payable ?? ""}
              thousandsGroupStyle="lakh"
              prefix="₹"
              decimalSeparator="."
              displayType="number"
              decimalScale={2}
              thousandSeparator={true}
              onValueChange={(values) => {
                setAddTdsData({ ...addTdsData, tds_payable: values.value });
              }}
            />
          </div>

          <div className="mt-20">
            <button className="button-primary" type="submit">Submit</button>
            <button className="button-outlined-secondary" type="button" onClick={cancelAddFormHandler}>cancel</button>
          </div>
        </ValidatorForm>
      </div>
    </>
  );
}